export enum ToastType {
  SUCCESS,
  ERROR,
}
